export default __webpack_public_path__ + "static/Bio_Toxin-3855502b45c39cf89ea1176e21a629f6.png";